import * as yup from "yup";

const characterReferenceSchema = yup.object({
    lastName: yup.string().trim().required("Last Name is required."),

    firstName: yup.string().trim().required("First name is required.")
});

export default characterReferenceSchema;
